import { useEffect, useMemo, useState } from "react";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { Box, Stack, Typography } from "@mui/material";
import { patchInvestigation } from "../../../../../apis";
import { useConstants } from "../Main/useConstants";
import { InvestigationSectionHeader } from "../components/InvestigationSectionHeader";
import { InvestigationAdvertisement } from "../components/InvestigationAdvertisement";
import { AddEvidence } from "./AddEvidence";
import { SingleEvidence } from "./SingleEvidence";
import { Separator } from "../components";

export const Evidences = ({
  investigation,
  setInvestigation,
  justView,
  handleSelectedSection,
  openConfirmDeleteModal,
  closeModalConfirm,
  onReload,
}) => {
  const [t] = useTranslation("investigation");

  const { enums } = useConstants();

  const [evidences, setEvidences] = useState(investigation?.evidences ?? []);

  const [isEditing, setIsEditing] = useState(false);
  const [selectedEvidence, setSelectedEvidence] = useState(null);

  const someEvidenceExist = useMemo(() => {
    if (evidences.length > 0) return true;
    return false;
  }, [evidences]);

  useEffect(() => {
    if (investigation.evidences != null) {
      setEvidences(investigation.evidences);
    } else {
      setEvidences([]);
    }
  }, [investigation?.evidences]);

  const handleSaveEvidenceDetails = async (newEvidences) => {
    const objToSave = {
      folder: {
        evidences: newEvidences,
      },
    };

    try {
      await patchInvestigation(investigation.alias, objToSave);
      setInvestigation({ ...investigation, evidences: newEvidences });
      setSelectedEvidence(null);
      setIsEditing(false);
      onReload();
    } catch (error) {
      console.error(error);
    }
  };

  const advanced = investigation.advance ?? false;

  if (!someEvidenceExist && justView) return null;

  return (
    <Box className="dyTheme1">
      {!isEditing && !justView && (
        <InvestigationSectionHeader
          text={t("Evidences.add_evidences_to_investigation")}
          buttonText={t("Evidences.add_evidence")}
          buttonIcon="outline_origin_search"
          onClick={() => setIsEditing(true)}
        />
      )}

      {!someEvidenceExist && !isEditing && !justView && (
        <InvestigationAdvertisement
          title={t("Evidences.no_evidences_loaded")}
          description={t(
            "Evidences.section_to_attach_and_manage_evidences_of_investigation"
          )}
        />
      )}

      {someEvidenceExist && justView && (
        <Separator
          text={t("Evidences.evidences")}
          icon="outline_search_evidence"
          iconButton="outline_edit"
          onClick={() => handleSelectedSection(enums.sections.evidences)}
          sx={{ marginBottom: 1.5 }}
        />
      )}

      {someEvidenceExist && !isEditing && (
        <Stack padding={justView ? 0 : 2} spacing={2}>
          {evidences.map((evidence, idx) => (
            <SingleEvidence
              key={idx}
              idx={idx}
              evidence={evidence}
              evidences={evidences}
              setEvidences={setEvidences}
              setSelectedEvidence={setSelectedEvidence}
              setIsEditing={setIsEditing}
              handleSaveEvidenceDetails={handleSaveEvidenceDetails}
              justView={justView}
              advanced={advanced}
              openConfirmDeleteModal={openConfirmDeleteModal}
              closeModalConfirm={closeModalConfirm}
            />
          ))}
        </Stack>
      )}

      {isEditing && (
        <AddEvidence
          evidences={evidences}
          selectedEvidence={selectedEvidence}
          setSelectedEvidence={setSelectedEvidence}
          setIsEditing={setIsEditing}
          handleSaveEvidenceDetails={handleSaveEvidenceDetails}
        />
      )}
    </Box>
  );
};
